import {
  UPDATE_FACILITY_HOLIDAY,
  UPDATE_FACILITY_HOLIDAY_SUCCESS,
  UPDATE_FACILITY_HOLIDAY_ERROR,
  UPDATE_FACILITY_HOLIDAY_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateFacilityHoliday = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FACILITY_HOLIDAY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_FACILITY_HOLIDAY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_FACILITY_HOLIDAY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_FACILITY_HOLIDAY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateFacilityHoliday;
